function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M92.1,184.2C41.3,184.2,0,142.9,0,92.1S41.3,0,92.1,0s92.1,41.3,92.1,92.1S142.9,184.2,92.1,184.2z M92.1,13 C48.5,13,13,48.5,13,92.1s35.5,79.1,79.1,79.1s79.1-35.5,79.1-79.1S135.8,13,92.1,13z"
})));

var SvgHoop = function SvgHoop(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 184.2 184.2",
    style: {
      enableBackground: "new 0 0 184.2 184.2"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/hoop.a23262c7.svg";
export { SvgHoop as ReactComponent };